import { Injectable } from '@angular/core';
//import { PersistenceService, StorageType } from 'angular-persistence';
import { PageControl } from '../objects/main';

@Injectable()
export class LanguageService {
  private currentLang: TranslatedLanguage;

  constructor() {
    let storedLang = localStorage.getItem('storedLang');

    if (storedLang == undefined) {
      this.currentLang = new TranslatedLanguage();
    } else {
      this.currentLang = JSON.parse(storedLang);
    }
  }

  current(): TranslatedLanguage {
    return this.currentLang;
  }

  change(lang: TranslatedLanguage) {
    this.currentLang = lang;
    this.onLanguageChange();
  }

  saveCookie(lang: TranslatedLanguage) {
    const _lang = JSON.stringify(lang);
    localStorage.setItem('storedLang', _lang);
  }

  getCountryFromCurrentLanguage(): string {
    switch (this.current().code) {
      case 'pt-BR': return 'Brazil';
      case 'en-US': return 'United States of America';
      default: return 'United States of America';
    }
  }


  private onLanguageChange() {
    return this.current().flag;
  }
}


@Injectable()
export class TranslatedLanguage {
  id: string;
  code: string;
  name: string;
  flag: string;
  createOn: string;
  updatedAt: string;
  currency: string;

  constructor() {
    this.code = "pt-BR";
    this.flag = "pt";
    this.name = "Português (BR)";
    this.createOn = "";
    this.updatedAt = "";
    this.currency = 'BRL';
  }
}

export class LanguagesPainelSearch {
  pageControl: PageControl = new PageControl;
  // completenessRange: MinMax = new MinMax;
  // searchQuery: string;
  // countryContinent: string[] = [];
  // populationRanges: MinMax[] = [];
  // topAreas: string[] = [];
}
